// src/components/auth/DefaultCompanyInfoPanel.jsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Still needed if FeatureCard expects icon object
import { faChartLine, faUtensils, faRobot } from '@fortawesome/free-solid-svg-icons';
import { Button, Image } from 'react-bootstrap';
import FeatureCard from './ui/FeatureCard'; // Assuming this is the correct path to your FeatureCard
import './LoginPageSidePanel.css'; // Path to your side panel styles

const MyFitMenuLogoPath = '/logo-light.png'; // Ensure this is in /public

const DefaultCompanyInfoPanel = () => {
    const features = [
        {
            icon: faUtensils,
            description: "AI Recipe Generator & Personalized Meal Planning.",
        },
        {
            icon: faRobot,
            description: "Your AI Nutrition Coach and Smart Food Scanner.",
        },
        {
            icon: faChartLine,
            description: "Track your health journey with insightful charts and personalized stats.",
        }
    ];

    return (
        <div className="side-panel-content text-center px-3">
            <Image
                src={MyFitMenuLogoPath}
                alt="MyFit Menu AI Logo"
                fluid
                className="mb-4" // side-panel-logo class removed as styling is minimal
                style={{ maxHeight: '180px' }} // Adjusted from 200px for better proportion, but use your value if 200px is intended.
            />
            <h2 className="side-panel-title mb-3">Smarter Nutrition Starts with MyFit Menu AI 🚀</h2>
            <p className="side-panel-subtitle mb-4 lead">
                Upload meals, scan barcodes, and unlock personalized health insights in seconds—powered by next-gen AI.
            </p>

            {/* Container for FeatureCards */}
            <div className="d-grid gap-3 mb-4">
                {features.map((feature, index) => (
                    <FeatureCard
                        key={index}
                        icon={feature.icon} // Pass the FontAwesome icon object
                        title={feature.description} // The main description IS the "title" in this context
                        // text="" // No secondary descriptive text for this particular design

                        // Overriding FeatureCard's default props for side panel styling:
                        cardClassName="feature-item text-white border-0 shadow-none" // Use feature-item for background, ensure text is white, remove border/shadow
                        iconContainerClass="text-white mb-3 mx-auto" // Ensures icon is white, default spacing
                        iconSize="2x" // Matches your original direct FontAwesomeIcon usage

                        titleAs="p" // Render the title (our feature description) as a paragraph
                        titleClassName="side-panel-feature-title mb-0" // Custom class for styling, remove bottom margin if it's the only text

                    // textClassName can be ignored if text prop is empty or not used
                    />
                ))}
            </div>

            <Button
                variant="outline-light"
                size="lg"
                href="/about"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-auto fw-bold px-4 py-2" // mt-auto to help push it down if parent is flex column
            >
                Learn More
            </Button>
            <div className="side-panel-footer mt-5">
                © {new Date().getFullYear()} MyFit Menu AI. All rights reserved.
            </div>
        </div>
    );
};

export default DefaultCompanyInfoPanel;